import React from 'react';
import PropTypes from 'prop-types';
import * as momentPropTypes from 'react-moment-proptypes';

const DateDisplay = (props) => {
  const {
    title,
    date,
  } = props;

  return (
    <div className="period-display__date">
      <div className="title">{title}</div>
      <div className="date">{date && date.format('dddd DD/MM/YYYY')}</div>
    </div>
  );
};

DateDisplay.propTypes = {
  title: PropTypes.string,
  date: momentPropTypes.momentObj,
};

export default DateDisplay;

